var scope_0 = require('/home/runner/work/commerce-services/commerce-services/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/745b679a159ca4f6bcf31b6d1550bf24.js').default;
var scope_1 = require('/home/runner/work/commerce-services/commerce-services/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/afb688130651ffd7c7373481bf6ea7c8.js').default;
var scope_2 = require('/home/runner/work/commerce-services/commerce-services/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/cccc839c8921b2b66d99c23d9cfe7fb9.js').default;
var scope_3 = require('/home/runner/work/commerce-services/commerce-services/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    